import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./App.scss";
import Layout from "./components/Layout/layout";
import Home from "./components/Home/home";
import Park from "./components/Park/park";
import Schedule from "./components/Schedule/schedule";
import Pricing from "./components/Pricing/pricing";

// Makes in-page anchor links (e.g. /#trial, /#programs — used by our
// Facebook/Google posts and the menu) actually scroll to the section,
// and resets scroll to the top on plain page changes.
function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    const id = hash.replace("#", "");
    let tries = 0;
    const timer = setInterval(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        clearInterval(timer);
      } else if (++tries > 15) {
        clearInterval(timer);
      }
    }, 100);
    return () => clearInterval(timer);
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/instructors" element={<Park />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/reviews" element={<Pricing />} />        </Route>
      </Routes>
    </>
  );
}

export default App;
